module.exports = __webpack_public_path__ + "assets/img/952c198e7aa5b780ed50a209227a79f0.png";